// React
import { Dispatch } from "react";

// Reducer
import { TAction } from "./reducer";

// MUI
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";

// Components
import EditModeContent from "./EditMode";

// Validation
import { TErrors } from "./validation";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ReadOnlyContent from "./ReadOnly";
import { IEligibilityRequirement } from "../../types/spiffSetup";
import { IOEM } from "@/Common/interfaces/location";
import { IVariableOperationsGpsBonusSetup } from "@/PayPlans/types/sections/variableOperationsGpsBonus";

interface IEligibilityRequirementsDialogProps {
	isOpen: boolean;
	close: () => void;
	title?: string;
	errorTitle?: string;
	spiffType: string;
	isEditMode: boolean;
	dispatch?: Dispatch<TAction>;
	errors: TErrors;
	useSectionsErrors?: () => any;
	state: IEligibilityRequirement | IVariableOperationsGpsBonusSetup;
	oems: IOEM[];
}

const EligibilityRequirementsDialog = (props: IEligibilityRequirementsDialogProps) => {
	const { dispatch, isOpen, close, title, errorTitle, spiffType, isEditMode, errors, state, oems, useSectionsErrors } = props;

	const handleUpdateEligibilityRequirements = (updatedState: TAction) => {
		if (dispatch === undefined) {
			return;
		}
		dispatch(updatedState);
	};

	return (
		<Dialog
			classes={{
				paper: "!rounded-[10px] !shadow-md pb-5",
			}}
			open={isOpen}
			onClose={close}
			PaperProps={{
				style: {
					maxWidth: "1444px",
					minHeight: "300px",
				},
			}}
			disableEscapeKeyDown
			onDoubleClick={(e) => {
				e.stopPropagation();
			}}
		>
			<DialogTitle>
				{title ? (
					<Typography className={"!font-montserrat !text-2xl !font-medium !text-default !mt-4"}>{title}</Typography>
				) : (
					<Typography className={"!font-montserrat !text-2xl !font-medium text-error"}>{errorTitle}</Typography>
				)}
				<IconButton className="!absolute !right-1 !top-1 !text-default" aria-label="close" onClick={close}>
					<CloseRoundedIcon fontSize="small" />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				{isEditMode ? (
					<EditModeContent
						oems={oems}
						spiffType={spiffType}
						eligibilityRequirements={state}
						updateEligibilityRequirements={handleUpdateEligibilityRequirements}
						errors={errors}
						useSectionsErrors={useSectionsErrors}
					/>
				) : (
					<ReadOnlyContent spiffType={spiffType} requirements={state} />
				)}
			</DialogContent>
		</Dialog>
	);
};

export default EligibilityRequirementsDialog;
